import { ProvidersPage } from "./providers";

export const Providers = ProvidersPage;
